import { memo } from "react";

import { buildHecSrcInlineJs } from "./hec-src-inline-js";

/**
 * `hec_src` entry-attribution cookie — the client-backstop inline `<script>`
 * (SFCC-12091). The snippet itself (and the full why) lives in
 * `hec-src-inline-js.ts`; this wrapper only renders it per the
 * `gtm-inline.tsx` conventions. Rendered inside the contiguous body-top
 * inline-script run in root.tsx, BEFORE the GTM container.
 */
const HEC_SRC_INLINE_JS = buildHecSrcInlineJs();

export const HecSrcInlineScript = memo(function HecSrcInlineScript({
  nonce,
}: {
  nonce?: string;
}) {
  return (
    <script
      suppressHydrationWarning
      nonce={nonce}
      dangerouslySetInnerHTML={{ __html: HEC_SRC_INLINE_JS }}
    />
  );
});
